<template>
  <div class="container">
    <div class="relation">
      <div class="relation-body">
        <div class="relation-view relation-view-1">
          <img class="l-map" src="/static/img/map_bg.c1947d06.png" alt="map" />
        </div>
        <h3 class="relation-view relation-view-2">联系播聘</h3>
        <div class="relation-view relation-view-3">
          <div class="relation-view-list relation-view-list-1">
            <div class="relation-view-label">战略合作(商务/市场)</div>
            <div class="relation-view-value">邮箱: {{ $config.email }}</div>
          </div>
          <div class="relation-view-list">
            <div class="relation-view-label">投诉与建议</div>
            <div class="relation-view-value">邮箱: {{ $config.phone }}</div>
          </div>
          <div class="relation-view-list">
            <div class="relation-view-label">校园活动合作</div>
            <div class="relation-view-value">邮箱: {{ $config.adEmail }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyRelation",
  data() {
    return {
      phone: "0755-3456 7889",
      email: "ecom@foxmail.com"
    };
  }
};
</script>

<style scoped="scoped">
@import url("./company-relation.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-relation/company-relation.vue